<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <div class="block-content-full">
        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
          <div class="row mb-1">
            <div class="col-12 col-md-4 text-center text-md-left">
              <pageSize @changePageSize="changePageSize"></pageSize>
            </div>
            <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
              <div class="dt-buttons">
                <button
                  class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  tabindex="0"
                  aria-controls="DataTables_Table_1"
                  data-clipboard-text
                  @click="copy()"
                  type="button"
                  id="copybtnOntimeUserCarport"
                >
                  <span>复制</span>
                </button>
                <button
                  class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  @click="exportCSV()"
                  type="button"
                >
                  <span>导出</span>
                </button>
                <button
                  class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                  @click="print()"
                >
                  <span>打印</span>
                </button>
              </div>
            </div>
            <div class="col-12 col-md-4 text-center text-md-right">
              <div class="dataTables_filter">
                <label>
                  <input
                    type="search"
                    class="form-control"
                    placeholder="搜索"
                    v-model="key"
                    @keyup.enter="search()"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <section ref="print">
                  <p class="show-on-print print-title">临期用户</p>
                  <table
                    id="example"
                    class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                  >
                    <thead>
                      <tr>
                        <th
                          class="text-center sorting"
                          @click="getList('ID',$event)"
                          style="width: 60px; min-width:60px"
                        >#</th>
                        <th
                          class="text-left sorting"
                          @click="getList('CARPORT_WHITE_TYPE',$event)"
                          style="min-width:110px;"
                        >用户类型</th>
                        <th
                          class="text-left sorting"
                          @click="getList('USER_ID',$event)"
                          style="min-width:90px;"
                        >用户ID</th>
                        <th
                          class="text-left sorting"
                          @click="getList('MOBILE_PHONE',$event)"
                          style="min-width:100px;"
                        >手机号码</th>
                        <th
                          class="text-left sorting"
                          @click="getList('CARD_NO',$event)"
                          style="min-width:100px;"
                        >实体卡号</th>
                        <th
                          class="text-left sorting"
                          @click="getList('CELL_NAME',$event)"
                          style="min-width:100px;"
                        >适用范围</th>
                        <th
                          class="text-left sorting d-md-table-cell"
                          @click="getList('PACKAGE_TYPE',$event)"
                          style="min-width:125px;"
                        >时长包类型</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          @click="getList('PACKAGE_NAME',$event)"
                          style="min-width:125px;"
                        >时长包名</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          @click="getList('START_EFFECTIVE_TIME',$event)"
                          style="min-width:110px;"
                        >开始时间</th>
                        <th
                          class="text-left sorting"
                          @click="getList('EXPIRED_TIME',$event)"
                          style="min-width: 110px;"
                        >有效期至</th>
                        <th
                          class="text-left d-xl-table-cell sorting"
                          style="width: 110px; min-width:110px"
                          @click="getList('VALID_DAY',$event)"
                        >剩余天数</th>
                        <!-- <th
                          class="text-center d-xl-table-cell sorting"
                          style="width: 100px; min-width:100px"
                          @click="getList('STATE',$event)"
                        >用户状态</th>-->
                        <th
                          class="text-center no-print"
                          style="width: 100px;min-width: 100px;"
                          v-if="!isFlatComplex"
                        >操作</th>
                      </tr>
                    </thead>
                    <tbody v-if="agents.length">
                      <tr v-for="(agent, i) in agents" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-left">{{agent.CARPORT_WHITE_TYPE == 1 ? '白名单' : '普通'}}</td>
                        <td class="text-left">{{ agent.USER_ID }}</td>
                        <td class="text-left">{{agent.MOBILE_PHONE}}</td>
                        <td class="text-left">{{agent.CARD_NO}}</td>
                        <td class="text-left">{{ agent.CELL_NAME }}</td>
                        <td class="text-left d-md-table-cell">{{ showType(agent.PACKAGE_TYPE) }}</td>
                        <td class="text-left">{{agent.PACKAGE_NAME}}</td>
                        <td class="text-left d-xl-table-cell">{{ agent.START_EFFECTIVE_TIME }}</td>
                        <td
                          class="text-left d-xl-table-cell"
                          style="min-width:80px;"
                        >{{ agent.EXPIRED_TIME }}</td>
                        <td
                          class="text-left d-xl-table-cell"
                          style="min-width:80px;"
                        >{{ agent.VALID_DAY }}</td>
                        <!-- <td class="text-center">
                          <div class="custom-control custom-switch custom-control-primary">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              name="example-sw-primary2"
                              :checked="agent.STATE == 2 ? false : true"
                              disabled
                            />
                            <label
                              class="custom-control-label"
                              :for="'dexample-sw-custom-success-state' + agent.ROWNUM"
                            ></label>
                          </div>
                        </td>-->

                        <td class="text-center no-print" v-if="!isFlatComplex">
                          <div class="btn-group">
                            <button
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              data-toggle="modal"
                              title="查看"
                              @click="$router.push({name:'carportWhiteUser', params:{id:agent.USER_ID,val:key,type:'see',white:false}})"
                              data-original-title="Edit"
                            >
                              <i class="fa fa-search"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="13">查无数据</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
              <div class="dataTables_info" role="status" aria-live="polite">
                页数
                <strong>{{ page }}</strong> /
                <strong>{{ totalPage }}</strong>
              </div>
            </div>
            <div class="col-sm-12 col-md-7 text-center text-md-right">
              <div class="dataTables_paginate paging_full_numbers">
                <el-pagination
                  v-if="agents && agents.length"
                  @current-change="handleCurrentChange"
                  :current-page="page"
                  :page-size="pageSize"
                  :small="isMobile"
                  :pager-count="pagerCount"
                  :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                  :total="total"
                  background
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      agents: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      wehitUserGroups: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      pro: "",
      city: "",
      dis: "",
      edit: "",
      created: false,
      form: {
        userId: "",
        groupId: "",
        mobilePhone: "",
        startEffectiveTime: "",
        expiredTime: "",
        resetHour: "",
        limitDuration: "",
        allowOther: "",
        userCard: "",
        type: ""
      },
      clipboard: null,
      sorting: "",
      orderBy: false,
      del: "",
      isFlatComplex: false,
      addBtn: Util.isHavePerm("cell/addUser"),
      editBtn:
        Util.isHavePerm("cell/addUser") ||
        Util.isHavePerm("user/updateUserInfo") ||
        Util.isHavePerm("timeLen/buyChargeUserPackage") ||
        Util.isHavePerm("cell/deleteUser"),
      stateBtn: Util.isHavePerm("cell/updateContraintUserState"),
      delBtn: Util.isHavePerm("cell/deleteUser")
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    searchKye() {
      return this.$store.state.searchKye;
    },
    params() {
      return this.$store.state.params;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },
    key(val, oldVal) {
      if (val.length == 0 || this.searchKye) {
        this.getList();
      }
    }
  },
  mounted() {
    if (this.$route.name == "userList") {
      this.isFlatComplex = true;
    }
    if (this.params.val) {
      this.key = this.searchKye;
    }
    this.getList();
    this.copy();
    setTimeout(() => {
      //   $('#example').DataTable({
      //     scrollX: true,
      //     searching: false,//搜索
      //     info: false,
      //     scrollCollapse: true,
      //     paging: false,
      //     fixedColumns: {
      //         leftColumns: 0,
      //         rightColumns: 1
      //     },
      //     drawCallback: function(){
      //         //重绘的回调执行
      //     }
      // } );
    }, 1000);
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    selectVal(ele) {
      this.selected = ele.target.value;
    },
    showType(str) {
      switch (str) {
        case "0":
          return "停车";
        case "1":
          return "停车+充电";
      }
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/User/ListByUserStopPackage/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.agents = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/User/ListByUserStopPackage/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[3].innerText;
      var btn = document.getElementById("copybtnOntimeUserCarport");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>